/* eslint-disable no-unused-vars */
import { memo } from 'react';
import { Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import './ShortVideoCardSkeleton.css';

function ShortVideoCardSkeleton() {
  const skeletonDummyArray = [
    { index: 1 },
    { index: 2 },
    { index: 3 },
    { index: 4 },
  ];
  return (
    <Grid container className='short-video-skeleton'>
      {skeletonDummyArray.map((item, _index) => (
        <Grid
          item
          container
          justifyContent='center'
          lg={3}
          md={3}
          sm={3}
          xs={6}
          style={{ paddingBottom: '5%', marginBottom: 30 }}
          key={item.index}
        >
          <div className='loader-klips'>
            <div className='loader-content'>
              <Skeleton
                variant='rect'
                height='130%'
                className='skeleton-main-style'
              />
            </div>
          </div>
        </Grid>
      ))}
    </Grid>
  );
}

export default memo(ShortVideoCardSkeleton);
